import React, { useCallback, useEffect, useState } from "react";
import Swal from "sweetalert2";
import { useAuth } from "hooks/useAuth";
import { printBookingPOS } from "../../utils/BookingPOSPrinter";

const PrintCustomBookingActivity = ({ booking, refetch, onSuccess, onError, isCustom = false }) => {
  const [selectedIndexes, setSelectedIndexes] = useState([]);
  const { user } = useAuth();

  useEffect(() => {
    if (booking?.activities?.length && isCustom) {
      setSelectedIndexes(booking.activities.map((_, index) => index));
    }
  }, [booking, isCustom]);

  const handlePrint = useCallback(async () => {
    if (isCustom && selectedIndexes.length === 0) {
      Swal.fire("No Activity Selected", "Please select at least one activity.", "warning");
      return;
    }

    const selectedActivities = isCustom
      ? booking.activities.filter((_, index) => selectedIndexes.includes(index))
      : booking.activities;

    try {
      await printBookingPOS(booking, { type: "custom", user, activities: selectedActivities });
      Swal.fire({ title: "Printing", text: "Booking is being processed...", icon: "success", timer: 1500, showConfirmButton: false });
      onSuccess?.();
      refetch?.();
    } catch (error) {
      console.error("Print Error:", error);
      Swal.fire("Error", "Failed to print booking", "error");
      onError?.();
    }
  }, [booking, isCustom, onError, onSuccess, refetch, selectedIndexes, user]);

  const toggleActivity = (index) => {
    setSelectedIndexes((current) => current.includes(index) ? current.filter((item) => item !== index) : [...current, index]);
  };

  return (
    <div>
      {isCustom && (
        <div className="mb-4">
          <h5 className="mb-2">Please select activities to print:</h5>
          <div className="d-flex flex-column gap-2">
            {(booking.activities || []).map((activity, index) => (
              <div key={index} className="form-check">
                <input className="form-check-input" type="checkbox" id={`activity-${index}`} checked={selectedIndexes.includes(index)} onChange={() => toggleActivity(index)} />
                <label className="form-check-label" htmlFor={`activity-${index}`}>
                  {activity.activity} <span className="text-muted">(Qty: {activity.qty})</span>
                </label>
              </div>
            ))}
          </div>
        </div>
      )}
      <button className="btn btn-primary mb-3" onClick={handlePrint}>Print Selected Activities</button>
    </div>
  );
};

export default PrintCustomBookingActivity;
